import '../../../styles/Chip.css';
import { getChipColor } from './Chip.theme';
import { ChipColors, ChipProps } from './Chip.types';

export default ({ children, color = ChipColors.Primary }: ChipProps) => {
  const colorClass = getChipColor(color);
  return <div className={`chip ${colorClass}`}>{children}</div>;
};
